module.exports = __webpack_public_path__ + "static/media/Phone.82b64cfc.svg";